import {
  NavItemType,
} from "components/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";


const defaultChildMenus: NavItemType[] = [

];
export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/markets",
    name: "Markets",
    type: "none",
    isNew: false,
    children: defaultChildMenus,
  },
  {
    id: ncNanoId(),
    href: "/Blog",
    name: "Blog",
    type: "none",
    children: defaultChildMenus,
  },
  {
    id: ncNanoId(),
    href: "/Learn",
    name: "Learn",
    type: "none",
    children: defaultChildMenus,
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About",
    type: "none",
    children: defaultChildMenus,
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Support",
    type: "none",
    children: defaultChildMenus,
  },
];
